<template>
    <v-app id="customer_form">
			<v-alert
				v-model="alertStatus"
				dismissible
				type="success"
			>We have recieved your tax exemption. Upon verification your status will be updated.</v-alert>
			<v-container grid-list-xl>
				<v-layout wrap align-center>
					<v-flex xs12 sm6 d-flex>
						<v-text-field
							v-model="data.fName"
							v-validate="'required|max:20'"
							append-icon="edit"
							:counter="20"
							:error-messages="errors.collect('fname')"
							data-vv-name="fname"
							required
							label="First Name"
						></v-text-field>
					</v-flex>
					<v-flex xs12 sm6 d-flex>
						<v-text-field
							v-model="data.lName"
							v-validate="'required|max:20'"
							append-icon="edit"
							:counter="20"
							:error-messages="errors.collect('lname')"
							data-vv-name="lname"
							required
							label="Last Name"
						></v-text-field>
					</v-flex>
				</v-layout>
				<v-layout wrap align-center>
					<v-flex xs12 sm6 d-flex>
						<v-text-field
							v-model="data.email"
							v-validate="'required|email'"
							append-icon="email"
							:error-messages="errors.collect('email')"
							label="Email"
							data-vv-name="email"
							required
						></v-text-field>
					</v-flex>
					<v-flex xs12 sm6 d-flex>
						<v-select
							v-model="data.issue"
							:items="issueList"
							label="Issue"
							ref="issue"
							@click:append="closeIssue"
							item-text="name"
							item-value="name"
							v-validate="'required'"
							data-vv-name="issue"
							require
						>
							<template slot="selection" slot-scope="data">{{ data.item.name }}</template>
							<template slot="item" slot-scope="data">
								<template v-if="typeof data.item !== 'object'">
									<v-list-tile-content v-text="data.item"></v-list-tile-content>
								</template>
								<template v-else>
									<v-list-tile-content>
										<v-list-tile-title v-html="data.item.name"></v-list-tile-title>
									</v-list-tile-content>
								</template>
							</template>
						</v-select>
					</v-flex>
				</v-layout>
				<v-layout wrap align-center>
					<v-flex xs12 sm12 d-flex>
						<v-textarea
							name="input-3-1"
							label="What's wrong?"
							v-model="data.description"
							v-validate="'required|min:20'"
							:error-messages="errors.collect('description')"
							data-vv-name="description"
							required
						></v-textarea>
					</v-flex>
				</v-layout>
				<v-layout wrap align-center>
					<v-flex xs12 sm6 d-flex>
						<v-select
							v-model="data.enter"
							:items="enterList"
							label="Entered By"
							ref="enter"
							v-validate="'required'"
							hint="employee entering the ticket"
							data-vv-name="enter"
							require
							@click:append="closeEnter"
							item-text="text"
							item-value="value"
						></v-select>
					</v-flex>
				</v-layout>
				<v-layout wrap align-center>
					<v-flex xs6 sm6 d-flex>
						<vue-uppy-cloudinary
							preset="reqe2pqu"
							cloudName="kencove"
							:allowedFileTypes="allowedFileTypes"
							@uploaded="uploaded"
						/>
					</v-flex>
					<v-flex v-if="attachments.length!=0" xs6 sm6>
						<h3>Upload Files:</h3>
						<ul v-for="item in attachments" :key="item.etag">
							<li>{{ item.original_filename }}</li>
						</ul>
					</v-flex>
					<v-flex xs6 sm6 d-flex>
						<v-btn v-on:click="submitForm4" class="submit">Submit</v-btn>
					</v-flex>
				</v-layout>
				
			</v-container>
    </v-app>
</template>


<script>
import VueUppyCloudinary from 'vue-uppy-cloudinary'
import 'vue-uppy-cloudinary/dist/lib/vue-uppy-cloudinary.min.css'
import axios from 'axios'

export default {
	name: 'form3',
	components: {
		VueUppyCloudinary
	},
	data: () => ({
		valid: false,
		data:{
			fName: '',
			lName: '',
			email: '',
			issue: '',
			description: '',
			enter: '',
			fileData: [],
			phone: '',
			reference_type: '',
			reference_number: '',
			customer_number: '',
			channel: ''
		},
		issueList: [],
		enterList:  [],
		alertStatus: false,
		attachments: [],
		allowedFileTypes: ['image/*', 'video/*', 'application/*'],
	}),
	mounted() {
    this.$validator.localize("en", this.dictionary);
	},
	created() {
		console.log(this.$route.query);
		this.data.email = this.$route.query.Email;
    this.data.fName = this.$route.query.Name_First;
    this.data.lName = this.$route.query.Name_Last;
    this.data.issue = this.$route.query.Issue;
    // this.data.phone = this.$route.query.PhoneNumber;
    this.data.reference_type = this.$route.query.ReferenceType;
    this.data.reference_number = this.$route.query.ReferenceNumber;
    this.data.customer_number = this.$route.query.CustomerNumber;
    this.data.channel = this.$route.query.Channel;
		axios
      .get(
        "https://api-kencove.azurewebsites.net/api2/vue/cs_form/issue_types",
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      )
      .then(response => {
				var tempList = [];
				for(let i=0; i<response.data.categories.length; i++){
					tempList.push({ 'header': response.data.categories[i].name });
					for(let j=0; j<response.data.categories[i].types.length; j++){
						tempList.push({ 'name': response.data.categories[i].types[j].name, 'group': response.data.categories[i].name });
					}
				}
				this.issueList = tempList;
      })
      .catch(error => {
        console.log(error.response);
			});
		axios
      .get(
        "https://api-kencove.azurewebsites.net/api2/vue/cs_form/entered_by",
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      )
      .then(response => {
				this.enterList = response.data;
      })
      .catch(error => {
        console.log(error.response);
      });
	},
	methods: {
		submitForm4() {
			this.$validator.validateAll().then(valid => {
        if (valid) {
					console.log(this.data);
          this.alertStatus = this.$store.dispatch("submitForm4", this.data);
        }
      });
		},
		uploaded(fileData) {
			this.attachments.push(fileData);
			this.data.fileData.push(fileData);
		},
		closeIssue () {
      if(this.$refs.issue.isMenuActive == true) this.$refs.issue.isMenuActive = false;      
		},
		closeEnter () {
      if(this.$refs.enter.isMenuActive == true) this.$refs.enter.isMenuActive = false;      
    }
	}	
}

</script>



// WEBPACK FOOTER //
// customer_interaction_form.vue?b3cdb590